
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-instagram",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","stroke":"currentColor","fill":"transparent","class":"icon i-instagram"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 2.43c3.28 0 3.67 0 5 .07a6.8 6.8 0 012.28.43 3.79 3.79 0 011.41.92 3.79 3.79 0 01.92 1.41 6.8 6.8 0 01.43 2.28c.05 1.29.07 1.68.07 5s0 3.67-.07 5a6.8 6.8 0 01-.43 2.28 4.09 4.09 0 01-2.33 2.33 6.8 6.8 0 01-2.28.43c-1.29.05-1.68.07-5 .07s-3.67 0-5-.07a6.8 6.8 0 01-2.28-.43 3.79 3.79 0 01-1.41-.92 3.79 3.79 0 01-.92-1.41 6.8 6.8 0 01-.43-2.28c0-1.29-.07-1.68-.07-5s0-3.67.07-5a6.8 6.8 0 01.43-2.28 3.79 3.79 0 01.92-1.41 3.79 3.79 0 011.41-.92 6.8 6.8 0 012.32-.43c1.29 0 1.68-.07 5-.07m0-2.21c-3.33 0-3.75 0-5.06.07a8.81 8.81 0 00-3 .58 6 6 0 00-2.2 1.41A6 6 0 00.87 4.46a8.81 8.81 0 00-.58 3C.24 8.75.22 9.17.22 12.5s0 3.75.07 5.06a8.81 8.81 0 00.58 3 6 6 0 001.41 2.18 6 6 0 002.18 1.41 8.81 8.81 0 003 .58c1.31.05 1.73.07 5.06.07s3.75 0 5.06-.07a8.81 8.81 0 003-.58 6.19 6.19 0 003.59-3.59 8.81 8.81 0 00.58-3c.05-1.31.07-1.73.07-5.06s0-3.75-.07-5.06a8.81 8.81 0 00-.58-3 6 6 0 00-1.41-2.18A6 6 0 0020.54.87a8.81 8.81 0 00-3-.58C16.25.24 15.83.22 12.5.22z"}}),_c('path',{attrs:{"d":"M12.5 6.19a6.31 6.31 0 106.31 6.31 6.32 6.32 0 00-6.31-6.31zm0 10.4a4.09 4.09 0 114.09-4.09 4.09 4.09 0 01-4.09 4.09z"}}),_c('circle',{attrs:{"cx":"19.05","cy":"5.95","r":"1.47"}})])
          )
        }
      }
    